import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-has-coupon',
    templateUrl: './icon-has-coupon.component.html',
    styleUrls: ['./icon-has-coupon.component.scss']
})
export class IconHasCouponComponent implements OnInit {

    @Input() cssClass = '';

    constructor() { }

    ngOnInit() { }
}
